import Phaser from "phaser";
import LoadingScene from "@/games/Cooking/scenes/LoadingScene";
import QuestionScene from "@/games/Cooking/scenes/QuestionScene";
import PlayScene from "@/games/Cooking/scenes/PlayScene";
import AnsCorrectPlayScene from "@/games/Cooking/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/games/Cooking/scenes/AnsWrongPlayScene";
import BossScene from "@/games/Cooking/scenes/BossScene";
import LandingScene from "@/games/Cooking/scenes/LandingScene";
import Settings from "@/games/Cooking/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
